<template>
  <div class="box" v-if="!isAgreeUseCookie && !loginChange">
    <div>
      <div>我们使用Cookie以使您获得更好的体验，提供网站流量分析功能。</div>
      <div>我们的Cookie政策提供了有关我们如何使用Cookie的详细信息。单击“我知道了”即表示您同意我们使用Cookie，并请参阅我们的<router-link to="/policy" tag="span" class="privacy-txt">【隐私政策】</router-link>以获取更多信息。</div>
    </div>
    <div class="confirm-btn" @click="handleEnsure">我知道了</div>
  </div>
</template>

<script>
export default {
  computed: {
    isAgreeUseCookie() {
        return this.$store.state.Index.isAgreeUseCookie;
    },
     isLoginSuccess() {
        return this.$store.state.Index.isLoginSuccess;
    },
    loginChange() {
      return this.$store.state.loginchange.loginChange
    }
  },
  methods: {
    handleEnsure() {
      this.$store.dispatch('changeCookie')
    }

  }
}
</script>
<style lang="less" scoped>
  .box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    z-index: 10001;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.70);
    height: .84rem;
    padding: 15px 130px;
    font-size: .18rem;
    line-height: .27rem;
    color: #fff;
    .privacy-txt{
      color: #0067B2;
      cursor: pointer;
    }
    .confirm-btn{
      width: 1.5rem;
      height: .54rem;
      line-height: .54rem;
      text-align: center;
      border: 1px solid #FFFFFF;
      cursor: pointer;
    }
  }

</style>




// WEBPACK FOOTER //
// src/components/common/PolicyBottom.vue